import React, { Fragment, useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import styles from "@/styles/mobile_best_sellers.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper";
import { homeLinks } from "@/data/home";
import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";
import ProductCard from "../product-card/product-card";
import arrow from "../../assets/images/arrow.png";

SwiperCore.use([Navigation, Pagination]);

const Mobile_Best_Sellers = () => {
  const [data, setData] = useState<any>([]);
  useEffect(() => {
    loadCustomerFavourite();
  }, []);

  const loadCustomerFavourite = async () => {
    const { data } = await httpClient.get(endpoints.home.customerFavourites(), {
      params: { limit: 4 },
    });
    setData(data);
  };
  return (
    <Fragment>
      {!!data.length && (
        <section className={styles.best_sellers}>
          <div className="container best-sellers-d">
            <div className={styles.best_sellersheader}>
              <div className="row">
                <div className="col-md-12">
                  <div className={styles.h2}>{homeLinks.bestSeller.title}</div>
                </div>
              </div>
              <div className={styles.best_sellers_main}>
                <Swiper
                  className="swiper-navigation-black"
                  navigation={true}
                  spaceBetween={10}
                  slidesPerView={2}
                  breakpoints={{
                    640: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    1024: {
                      slidesPerView: 4,
                    },
                    1200: {
                      slidesPerView: 4,
                    },
                  }}
                >
                  {data.slice(0, 20).map((v: any, i: any) => (
                    <SwiperSlide key={i}>
                      <div className={styles.jwellery}>
                        <ProductCard product={v} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Link href="/customers-favourite" passHref>
                    <div className={styles.btn_get_started}>
                      SEE ALL Products
                      <Image
                        src={arrow}
                        className="img-fluid"
                        alt="features10"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default Mobile_Best_Sellers;
